import React from 'react';
const LicenseTooltip = ({
  title
}) => {
  return <div style={{
    maxWidth: 350
  }} data-sentry-component="LicenseTooltip" data-sentry-source-file="LicenseTooltip.jsx">
      <strong>{title}</strong> is not included in your license. <br /> Contact{' '}
      <a href={`mailto:${process.env.salesEmail}`}>{process.env.salesEmail}</a> for access.
    </div>;
};
export default LicenseTooltip;